import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import React, { useContext } from 'react';

import { UserOrganization } from '../../../common/constants/userOrganization';
import { FeatureFlagsContext } from '../../../common/featureFlagsWrapper';
import { AuthContext } from '../../../features/login/AuthWrapper';
import { ReferralCountContext } from '../../referral-action-required/ReferralCountContext';

const REFERRAL_ACTION_REQUIRED_PATH = '/workbench/referrals/action-required';

/**
 * Persistent proactive-notification badge shown in the Workbench header next to the user's name.
 * Displays the count of referrals requiring action from the logged-in user; hidden when there are none.
 * Clicking opens the Referral Action Required tab in a new browser tab (Case Referral Phase 2, Feature 1).
 */
export const ReferralNotificationBadge = () => {
  const auth = useContext(AuthContext);
  const { flags } = useContext(FeatureFlagsContext);
  const isReferralVisible =
    flags.isCaseReferralEnabled &&
    flags.isCaseReferralPhase2Enabled &&
    auth.userOrganization === UserOrganization.ETHOS;
  const { count } = useContext(ReferralCountContext);

  if (!isReferralVisible || count <= 0) {
    return null;
  }

  const label = `${count} pending referral${count === 1 ? '' : 's'}`;
  const openReferralTab = () =>
    window.open(REFERRAL_ACTION_REQUIRED_PATH, '_blank');

  return (
    <Box
      role="button"
      tabIndex={0}
      aria-label={label}
      onClick={openReferralTab}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openReferralTab();
        }
      }}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        cursor: 'pointer',
        backgroundColor: '#E53E3E',
        color: '#fff',
        borderRadius: '12px',
        paddingInline: '10px',
        paddingBlock: '3px',
        fontSize: '0.8rem',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        '&:hover': { opacity: 0.85 },
      }}
    >
      <FontAwesomeIcon icon={faCircle} style={{ fontSize: 8 }} />
      {label}
    </Box>
  );
};

export default ReferralNotificationBadge;
